import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
const WelcomeMessage = () => {
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check local storage if the welcome message has been shown
    const hasSeenWelcome = localStorage.getItem('hasSeenWelcome');

    if (!hasSeenWelcome) {
      // Check profile completion with Axios
      axios
        .get(
          // 'http://127.0.0.1:8000/account/check-profile-complete/',
          `${API_BASE_URL}/account/check-profile-complete/`,
          {
            headers: {
              Cookie:
                'csrftoken=QCCBPPKQOa8fILxuLnwis8lJdPC8OzVe; sessionid=gxg1xfcs2w5yxe6rxul2b1vqcwboitnx',
            },
            withCredentials: true, // Ensure cookies are sent with request if needed
          }
        )
        .then(response => {
          if (!response.data.filled) {
            setShowPopup(true); // Show popup if profile is incomplete
          }
        })
        .catch(error =>
          console.error('Error checking profile completion:', error)
        );

      localStorage.setItem('hasSeenWelcome', 'true');
    }
  }, []);

  const handleProfileDetails = () => {
    navigate('/profileDetails');
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <>
      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="md:w-2/5 w-5/6 h-auto max-w-xl bg-white md:px-8 px-5 py-4 rounded-lg shadow-lg text-center">
            <div className="flex justify-between">
              <div></div>
              <button
                onClick={closePopup}
                className="text-black text-2xl font-bold hover:text-red-500 md:block hidden"
              >
                &times;
              </button>
            </div>

            <h2 className="md:text-2xl text-xl font-bold md:mb-4 mb-2 mt-2">
              Welcome to FinWise!!
            </h2>

            <p className="md:text-lg text-sm md:mb-14 mb-8">
              To continue accessing personalized services and expert solutions,
              please complete your profile.
            </p>
            <div className="flex flex-col lg:flex-row items-center justify-evenly mb-4 space-y-2 lg:space-y-0 lg:space-x-4">
              <button
                onClick={closePopup}
                className="bg-headerBtn text-white text-xs md:text-sm w-60 md:w-44 px-2 md:px-4 py-2 rounded-lg hover:bg-btnHover focus:outline-none transition-all duration-200"
              >
                Later
              </button>
              <button
                onClick={handleProfileDetails}
                className="bg-headerBtn text-white text-xs md:text-sm w-60 md:w-44 px-2 md:px-4 py-2 rounded-lg hover:bg-btnHover focus:outline-none transition-all duration-200"
              >
                Complete Profile
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WelcomeMessage;

// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// const WelcomeMessage = () => {
//   // const [showPopup, setShowPopup] = useState(true);
//   const navigate = useNavigate();
//   // const handleDashboardClick = () => navigate('/dashboard');

//     const [showPopup, setShowPopup] = useState(false);
//   // useEffect(() => {
//   //   // Show the popup when the component mounts
//   //   setShowPopup(true);
//   // }, []);

//     useEffect(() => {
//       // Check if the popup has been shown in this session
//       const hasPopupBeenShown = sessionStorage.getItem('popupShown');

//       if (!hasPopupBeenShown) {
//         setShowPopup(true);
//         // Mark the popup as shown in this session
//         sessionStorage.setItem('popupShown', 'true');
//       }
//     }, []);

//   useEffect(() => {
//     // Check local storage if the welcome message has been shown
//     const hasSeenWelcome = localStorage.getItem('hasSeenWelcome');

//     if (!hasSeenWelcome) {
//       // If not, show the popup and set the status in local storage
//       setShowPopup(true);
//       localStorage.setItem('hasSeenWelcome', 'true');
//     }
//   }, []);

//   const handleProfileDetails = () => {
//     navigate('/profileDetails');
//   };

//   const closePopup = () => {
//     setShowPopup(false);
//   };

//   return (
//     <>
//       {showPopup && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//           <div className="md:w-2/5 w-5/6 h-auto max-w-xl bg-white md:px-8 px-5 py-4 rounded-lg shadow-lg text-center">
//             <div className="flex justify-between">
//               {/* empty div */}
//               <div></div>
//               {/* Close button */}
//               <button
//                 onClick={closePopup}
//                 className="text-black text-2xl font-bold hover:text-red-500 md:block hidden"
//               >
//                 &times;
//               </button>
//             </div>

//             <h2 className="md:text-2xl text-xl font-bold md:mb-4 mb-2 mt-2">
//               Welcome to FinWise!!
//             </h2>

//             <p className="md:text-lg text-sm md:mb-14 mb-8 ">
//               To continue accessing personalised services and expert solutions,
//               please complete your profile.
//             </p>
//             <div className="flex flex-col lg:flex-row items-center justify-evenly mb-4 space-y-2 lg:space-y-0 lg:space-x-4">
//               <button
//                 onClick={closePopup}
//                 className="bg-headerBtn text-white text-xs md:text-sm w-60 md:w-44 px-2 md:px-4 py-2 rounded-lg hover:bg-btnHover focus:outline-none transition-all duration-200"
//               >
//                 Later
//               </button>
//               <button
//                 onClick={handleProfileDetails}
//                 className="bg-headerBtn text-white text-xs md:text-sm w-60 md:w-44 px-2 md:px-4 py-2 rounded-lg hover:bg-btnHover focus:outline-none transition-all duration-200"
//               >
//                 Complete Profile
//               </button>
//             </div>

//             {/* <div className="flex items-center justify-evenly mb-4">
//               <button
//                 onClick={closePopup}
//                 className="bg-headerBtn text-white md:text-sm text-xs md:w-44 w-28 md:px-4 px-2  py-2 rounded-lg hover:bg-btnHover focus:outline-none"
//               >
//                 Later
//               </button>
//               <button
//                 onClick={handleProfileDetails}
//                 className="md:text-sm text-xs md:w-44 w-28 md:px-4 px-2 bg-headerBtn text-white  py-2 rounded-lg hover:bg-btnHover focus:outline-none"
//               >
//                 Complete Profile
//               </button>
//             </div> */}
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default WelcomeMessage;

// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';

// const WelcomeMessage = () => {
//   const navigate = useNavigate();
//   const [showPopup, setShowPopup] = useState(false);

//   useEffect(() => {
//     // Check if the profile is complete
//     const isProfileComplete = localStorage.getItem('isProfileComplete') === 'true';

//     // If the profile is not complete, show the welcome message
//     if (!isProfileComplete) {
//       // Check if the popup has already been shown in this session
//       const hasPopupBeenShown = sessionStorage.getItem('popupShown');

//       if (!hasPopupBeenShown) {
//         setShowPopup(true);
//         // Mark the popup as shown in this session
//         sessionStorage.setItem('popupShown', 'true');
//       }
//     }
//   }, []);

//   const handleProfileDetails = () => {
//     navigate('/profileDetails');
//   };

//   const closePopup = () => {
//     setShowPopup(false);
//   };

//   return (
//     <>
//       {showPopup && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//           <div className="md:w-2/5 w-5/6 h-auto max-w-xl bg-white md:px-8 px-5 py-4 rounded-lg shadow-lg text-center">
//             <div className="flex justify-between">
//               <div></div>
//               <button
//                 onClick={closePopup}
//                 className="text-black text-2xl font-bold hover:text-red-500 md:block hidden"
//               >
//                 &times;
//               </button>
//             </div>

//             <h2 className="md:text-2xl text-xl font-bold md:mb-4 mb-2 mt-2">
//               Welcome to FinWise!!
//             </h2>

//             <p className="md:text-lg text-sm md:mb-14 mb-8 ">
//               To continue accessing personalized services and expert solutions,
//               please complete your profile.
//             </p>
//             <div className="flex flex-col lg:flex-row items-center justify-evenly mb-4 space-y-2 lg:space-y-0 lg:space-x-4">
//               <button
//                 onClick={closePopup}
//                 className="bg-headerBtn text-white text-xs md:text-sm w-60 md:w-44 px-2 md:px-4 py-2 rounded-lg hover:bg-btnHover focus:outline-none transition-all duration-200"
//               >
//                 Later
//               </button>
//               <button
//                 onClick={handleProfileDetails}
//                 className="bg-headerBtn text-white text-xs md:text-sm w-60 md:w-44 px-2 md:px-4 py-2 rounded-lg hover:bg-btnHover focus:outline-none transition-all duration-200"
//               >
//                 Complete Profile
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default WelcomeMessage;

// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';

// const WelcomeMessage = () => {
//   const navigate = useNavigate();
//   const [showPopup, setShowPopup] = useState(false);

//   useEffect(() => {
//     // Check if the popup has already been shown in this session
//     const hasPopupBeenShown = sessionStorage.getItem('popupShown');

//     if (!hasPopupBeenShown) {
//       checkProfileComplete();
//     }
//   }, []);

//   const checkProfileComplete = async () => {
//     try {
//       const response = await axios.get(
//         'http://127.0.0.1:8000/account/check-profile-complete/',
//         {
//           headers: {
//             Cookie:
//               'csrftoken=QCCBPPKQOa8fILxuLnwis8lJdPC8OzVe; sessionid=gxg1xfcs2w5yxe6rxul2b1vqcwboitnx',
//           },
//         }
//       );

//       console.log('pofile complte?:', response.data);
//       // Assuming that the response indicates profile completion status
//       if (response.data.filled === false) {
//         setShowPopup(true);
//         sessionStorage.setItem('popupShown', 'true');
//       }
//     } catch (error) {
//       console.error('Error checking profile completion:', error);
//     }
//   };

//   const handleProfileDetails = () => {
//     navigate('/profileDetails');
//   };

//   const closePopup = () => {
//     setShowPopup(false);
//   };

//   return (
//     <>
//       {showPopup && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//           <div className="md:w-2/5 w-5/6 h-auto max-w-xl bg-white md:px-8 px-5 py-4 rounded-lg shadow-lg text-center">
//             <div className="flex justify-between">
//               <div></div>
//               <button
//                 onClick={closePopup}
//                 className="text-black text-2xl font-bold hover:text-red-500 md:block hidden"
//               >
//                 &times;
//               </button>
//             </div>

//             <h2 className="md:text-2xl text-xl font-bold md:mb-4 mb-2 mt-2">
//               Welcome to FinWise!!
//             </h2>

//             <p className="md:text-lg text-sm md:mb-14 mb-8 ">
//               To continue accessing personalized services and expert solutions,
//               please complete your profile.
//             </p>
//             <div className="flex flex-col lg:flex-row items-center justify-evenly mb-4 space-y-2 lg:space-y-0 lg:space-x-4">
//               <button
//                 onClick={closePopup}
//                 className="bg-headerBtn text-white text-xs md:text-sm w-60 md:w-44 px-2 md:px-4 py-2 rounded-lg hover:bg-btnHover focus:outline-none transition-all duration-200"
//               >
//                 Later
//               </button>
//               <button
//                 onClick={handleProfileDetails}
//                 className="bg-headerBtn text-white text-xs md:text-sm w-60 md:w-44 px-2 md:px-4 py-2 rounded-lg hover:bg-btnHover focus:outline-none transition-all duration-200"
//               >
//                 Complete Profile
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default WelcomeMessage;

// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';

// const WelcomeMessage = () => {
//   const navigate = useNavigate();
//   const [showPopup, setShowPopup] = useState(false);

//   useEffect(() => {
//     // Function to check if the profile is complete
//     const checkProfileComplete = async () => {
//       try {
//         const response = await axios.get(
//           'http://127.0.0.1:8000/account/check-profile-complete/',
//           {
//             headers: {
//               Cookie:
//                 'csrftoken=QCCBPPKQOa8fILxuLnwis8lJdPC8OzVe; sessionid=gxg1xfcs2w5yxe6rxul2b1vqcwboitnx',
//             },
//             withCredentials: true,
//           }
//         );

//         // Only show popup if the profile is not complete (filled is false)
//         if (!response.data.filled) {
//           const hasPopupBeenShown = sessionStorage.getItem('popupShown');

//           // Show the popup if it hasn't been shown in this session
//           if (!hasPopupBeenShown) {
//             setShowPopup(true);
//             sessionStorage.setItem('popupShown', 'true');
//           }
//         }
//       } catch (error) {
//         console.error('Error fetching profile completion status:', error);
//       }
//     };

//     checkProfileComplete();
//   }, []);

//   const handleProfileDetails = () => {
//     navigate('/profileDetails');
//   };

//   const closePopup = () => {
//     setShowPopup(false);
//   };

//   return (
//     <>
//       {showPopup && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//           <div className="md:w-2/5 w-5/6 h-auto max-w-xl bg-white md:px-8 px-5 py-4 rounded-lg shadow-lg text-center">
//             <div className="flex justify-between">
//               <div></div>
//               <button
//                 onClick={closePopup}
//                 className="text-black text-2xl font-bold hover:text-red-500 md:block hidden"
//               >
//                 &times;
//               </button>
//             </div>

//             <h2 className="md:text-2xl text-xl font-bold md:mb-4 mb-2 mt-2">
//               Welcome to FinWise!!
//             </h2>

//             <p className="md:text-lg text-sm md:mb-14 mb-8">
//               To continue accessing personalized services and expert solutions,
//               please complete your profile.
//             </p>
//             <div className="flex flex-col lg:flex-row items-center justify-evenly mb-4 space-y-2 lg:space-y-0 lg:space-x-4">
//               <button
//                 onClick={closePopup}
//                 className="bg-headerBtn text-white text-xs md:text-sm w-60 md:w-44 px-2 md:px-4 py-2 rounded-lg hover:bg-btnHover focus:outline-none transition-all duration-200"
//               >
//                 Later
//               </button>
//               <button
//                 onClick={handleProfileDetails}
//                 className="bg-headerBtn text-white text-xs md:text-sm w-60 md:w-44 px-2 md:px-4 py-2 rounded-lg hover:bg-btnHover focus:outline-none transition-all duration-200"
//               >
//                 Complete Profile
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default WelcomeMessage;
